import React, { FunctionComponent } from 'react';
import './style.scss';
import logo from '../../assets/images/BL-Logo-Auth.png';
import burger from '../../assets/icons/auth-burger.svg';

const AuthHeader: FunctionComponent = () => {

  return (
    <div className='auth-header'>
      <header className="auth-header-wrapper">
        <img className="auth-logo" src={logo} loading="lazy"/>
        <img src={burger} loading="lazy"/>
      </header>
    </div>
  );
};

export default AuthHeader;
